module.exports = __webpack_public_path__ + "img/button-bookmark.54b4ae41.svg";